import firebase from './'

const storage = firebase.storage()

export const getUrl = (path: string) => new Promise(async (resolve, reject) => {
    try {
        const url = await storage.ref(`Glasses/${path}`).getDownloadURL()
        resolve(url)
    } catch (error) { reject(error) }
})
